import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_grid = _resolveComponent("my-grid")!

  return (_openBlock(), _createBlock(_component_my_grid, {
    data: _ctx.allSyncEvents,
    columns: _ctx.columns,
    "initial-sort": _ctx.initialSort
  }, {
    customTemplate1: _withCtx(({props}) => [
      _createElementVNode("span", {
        innerHTML: props.dataItem[props.field]
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["data", "columns", "initial-sort"]))
}